module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"choose":"Выберите вакансию","fromVacancy":"Из вакансии","copy":"Из которой вы хотите скопировать список вопросов","copyBtn":"Скопировать вопросы из другой вакансии"}}')
  delete Component.options._Ctor
}
